import { getNewQuestionTemplateDeleteMedia } from '../getNewQuestionTemplate'

const QUESTION_MEDIA_NODE_TYPES = ['questionImage', 'questionAnimatedGIF']
const TEMPLATED_CHOICE_NODE_TYPES = ['choiceImage', 'choiceVideo', 'choiceSound', 'choiceAnimatedGIF', 'choice']

// Removes the placeholder node left behind by a failed media upload so the
// question is not autosaved with media that has no fileId.
// For question media the question template is reverted like a normal delete.
export function removeFailedMediaUploadNode(nodeId) {
  if (!window.view) return
  const { state } = window.view
  let mediaNode
  let mediaPos
  state.doc.descendants((node, pos) => {
    if (mediaNode) return false
    if (node.attrs.nodeId && node.attrs.nodeId === nodeId) {
      mediaNode = node
      mediaPos = pos
      return false
    }
    return true
  })
  if (!mediaNode || mediaNode.attrs.fileId) return // already removed or upload has succeeded

  const { tr } = state
  if (QUESTION_MEDIA_NODE_TYPES.includes(mediaNode.type.name)) {
    const $pos = state.doc.resolve(mediaPos)
    for (let depth = $pos.depth; depth > 0; depth -= 1) {
      const questionNode = $pos.node(depth)
      if (questionNode.type.name === 'question') {
        const questionPos = $pos.before(depth)
        const newTemplate = getNewQuestionTemplateDeleteMedia(questionNode.attrs.template)
        tr.setNodeMarkup(questionPos, null, { ...questionNode.attrs, template: newTemplate })
        questionNode.descendants((childNode, childOffset) => {
          if (TEMPLATED_CHOICE_NODE_TYPES.includes(childNode.type.name)) {
            tr.setNodeMarkup(questionPos + 1 + childOffset, null, { ...childNode.attrs, template: newTemplate })
          }
        })
        break
      }
    }
  }
  // setNodeMarkup keeps node sizes, so mediaPos is still valid
  tr.delete(mediaPos, mediaPos + mediaNode.nodeSize)
  tr.setMeta('addToHistory', false) // undo should not bring back a placeholder with no upload
  tr.setMeta('triggerParseDoc', true)
  window.view.dispatch(tr)
}
